.count {
  color: var(--color-black);
}
